<template>
  <v-layout row wrap justify-center fill-height>
    <v-layout row wrap justify-center fill-height style="max-width: 1440px">
      <v-flex xs12>
        <v-alert
            color="success"
            class="success notifications text-left text-xs-left"
            icon="check"
            value="true"
            v-if="success">{{success}}<br v-if="orderBackLinkUrl">
          <a v-if="orderBackLinkUrl" :href="orderBackLinkUrl" target="_blank" style="color: white;">{{$lang.success.continueTo}} {{extractUrl(orderBackLinkUrl)}}</a>
        </v-alert>
        <v-alert
            color="error"
            class="err"
            icon="warning"
            value="true"
            v-if="err">{{ err }}
        </v-alert>
        <v-alert
            color="error"
            class="err"
            icon="warning"
            value="true"
            v-if="!checkAcceptingOrders()">
          {{ $lang.errors.acceptingOrders }}
        </v-alert>
        <v-alert
            :color="remainingWorkingRanges.length === 0 ? 'error': 'success'"
            class="err"
            icon="warning"
            value="true"
            v-if="closed">
          <template v-if="remainingWorkingRanges.length === 0">{{ $lang.errors.restaurantClosed }}</template>
          <template v-else>{{ $lang.errors.restaurantPreorder }} {{ remainingWorkingRanges[0].start }}</template>
        </v-alert>
        <v-alert
            color="warning"
            class="warning"
            icon="warning"
            value="true"
            v-else-if="closingMessage && !closedMessage">{{ $lang.errors.restaurantSoon }}
        </v-alert>
        <v-alert
            color="warning"
            class="warning"
            icon="warning"
            value="true"
            v-else-if="closedMessage">{{ $lang.errors.restaurantReceiving }}
        </v-alert>
        <v-alert
            color="info"
            class="info"
            icon="info"
            value="true"
            v-if="$lang.current_lang === 'en' ? !!formatedHtmlHints['webshop.deactivation.en'] && company && !company.acceptingOrders : !!formatedHtmlHints['webshop.deactivation.de'] && company && !company.acceptingOrders"
            v-html="$lang.current_lang === 'en' ? formatedHtmlHints['webshop.deactivation.en'] : formatedHtmlHints['webshop.deactivation.de']">
        </v-alert>
        <v-layout row wrap class="py-2 pr-2 pl-3 mb-2 elevation-2" style="background-color: #2196f3 !important; width: 100%;"
            v-if="$lang.current_lang === 'en' ? !!formatedHtmlHints['webshop.page1.prefix.en'] : !!formatedHtmlHints['webshop.page1.prefix.de']"
            v-html="$lang.current_lang === 'en' ? formatedHtmlHints['webshop.page1.prefix.en'] : formatedHtmlHints['webshop.page1.prefix.de']">
        </v-layout>
      </v-flex>
      <v-flex xs12 md7 lg8 class="section categories" pa-0>
        <v-flex class="text-xs-center" v-if="!loaded">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-flex>
        <Categories @success="flashSuccess" v-else-if="catalog" :itemsList="itemsList" :notNested="true"/>
      </v-flex>
      <v-flex xs12 md5 lg4 class="section shopping-basket mb-3" v-if="catalog">
        <v-card :class="{'pa-4': $vuetify.breakpoint.mdAndUp}" id="vCardId" :flat="$vuetify.breakpoint.smAndDown" :style="$vuetify.breakpoint.smAndDown ? 'background-color: transparent;' : ''">
          <ShoppingBasket :successMessage="itemSuccess"/>
        </v-card>
      </v-flex>
      <v-flex xs12 class="pr-1">
        <v-layout row wrap class="pa-2 mb-2 elevation-2" style="background-color: #2196f3 !important; width: 100%;"
            v-if="$lang.current_lang === 'en' ? !!formatedHtmlHints['webshop.page1.postfix.en'] : !!formatedHtmlHints['webshop.page1.postfix.de']"
            v-html="$lang.current_lang === 'en' ? formatedHtmlHints['webshop.page1.postfix.en'] : formatedHtmlHints['webshop.page1.postfix.de']">
        </v-layout>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import ShoppingBasket from '@/components/webshop/ShoppingBasket';
import { appId } from '../const';
import auth from '../auth';

export default {
  components: {
    ShoppingBasket,
  },
  data: () => ({
    isLoggedIn: auth.isLoggedIn(),
    success: '',
    itemSuccess: '',
    err: '',
    loaded: false,
    htmlHints: [],
    formatedHtmlHints: {},
    orderBackLinkUrl: '',
  }),
  computed: {
    ...mapGetters({
      itemsList: 'items',
      contact: 'contact',
      addresses: 'addresses',
      addressesSet: 'addressesSet',
      company: 'company',
      catalog: 'catalog',
      categories: 'categories',
      closed: 'closed',
      remainingWorkingRanges: 'remainingWorkingRanges',
      closingMessage: 'closingMessage',
      closedMessage: 'closedMessage',
      intercomUser: 'intercomUser',
      width: 'width',
    }),
    showInfoPre() {
      if (this.$lang.current_lang === 'en') {
        return !!this.formatedHtmlHints['webshop.page1.prefix.en'];
      }
      if (this.$lang.current_lang === 'de') {
        return !!this.formatedHtmlHints['webshop.page1.prefix.de'];
      }
      return false;
    },
    showInfoPost() {
      if (this.$lang.current_lang === 'en') {
        return !!this.formatedHtmlHints['webshop.page1.postfix.en'];
      }
      if (this.$lang.current_lang === 'de') {
        return !!this.formatedHtmlHints['webshop.page1.postfix.de'];
      }
      return false;
    },
  },
  methods: {
    goToOrderLink() {
      window.open(this.orderBackLinkUrl, '_blank');
    },
    extractUrl(fullUrl) {
      let shortenedUrl = '';
      const el = document.createElement('a');
      el.href = fullUrl;
      const hostnameArr = el.hostname.split('.');
      if (hostnameArr.length < 3) shortenedUrl = hostnameArr[0];
      if (hostnameArr.length >= 3) shortenedUrl = hostnameArr[1];
      return shortenedUrl;
    },
    flashSuccess(event) {
      this.itemSuccess = event;
      setTimeout(() => {
        this.itemSuccess = '';
      }, 3000);
    },
    setupQuery() {
      this.$store.dispatch('setUserData', {
        firstName: decodeURIComponent(this.$route.query.first),
        lastName: decodeURIComponent(this.$route.query.last),
      });
    },
    formatHtmlHints() {
      for (let i = 0; i < this.htmlHints.length; i += 1) {
        this.formatedHtmlHints[this.htmlHints[i].name] = `<v-flex xs1><i class="material-icons pr-3">info</i></v-flex><v-flex xs11>${this.htmlHints[i].value}</v-flex>`;
      }
    },
    checkAcceptingOrders() {
      if (this.company) {
        return !!this.company.acceptingOrders;
      }
      return true;
    },
    initIntercom() {
      const companyData = this.$storage.company;
      if (companyData.address.country === 'AT') {
        let intercomPayload = {};
        if (this.isLoggedIn) {
          if (this.addresses.length === 0 && !this.addressesSet) {
            this.$store.dispatch('setIsFetchingUser', true);
            this.$webHelper.get('contact/fetchforauser', null, this.$router)
              .then((res) => {
                if (!res.success) {
                  this.err = this.$lang.errors.failedContactInfo;
                  return;
                }
                this.$store.dispatch('setContact', {
                  lastName: res.body.contact.lastName,
                  phone: res.body.contact.phone,
                });
                this.$store.dispatch('setIntercomUser', {
                  lastName: res.body.contact.lastName,
                  email: res.body.contact.email,
                });
                intercomPayload = {
                  name: this.intercomUser.lastName,
                  app_id: appId,
                  email: this.intercomUser.email,
                };
                this.$store.dispatch('setIsFetchingUser', false);
                setTimeout(() => {
                  window.Intercom('boot', intercomPayload);
                  this.$store.dispatch('setIntercomVisible', true);
                  window.Intercom('onUnreadCountChange', (count) => {
                    if (count > 0) {
                      window.Intercom('show');
                    }
                  });
                }, 200);
              });
          } else {
            intercomPayload = {
              name: this.intercomUser.lastName,
              app_id: appId,
              email: this.intercomUser.email,
            };
            setTimeout(() => {
              window.Intercom('boot', intercomPayload);
              this.$store.dispatch('setIntercomVisible', true);
              window.Intercom('onUnreadCountChange', (count) => {
                if (count > 0) {
                  window.Intercom('show');
                }
              });
            }, 200);
          }
        } else {
          intercomPayload = {
            app_id: appId,
          };
          setTimeout(() => {
            window.Intercom('boot', intercomPayload);
            this.$store.dispatch('setIntercomVisible', true);
            window.Intercom('onUnreadCountChange', (count) => {
              if (count > 0) {
                window.Intercom('show');
              }
            });
          }, 200);
        }
      }
    },
  },
  created() {
    if (this.$route.params.resource) {
      const oldResourceId = localStorage.getItem('webShopResourceId') || null;
      localStorage.setItem('webShopResourceId', this.$route.params.resource);
      this.$storage.company = null;
      this.$store.dispatch('setCompany', null);
      this.$storage.catalog = null;
      this.$storage.order = null;
      this.$store.dispatch('clearCart');
      this.$webHelper.get(`webshopresource/fetchbyexternalid/${this.$route.params.resource}`, null, this.$router)
        .then((res) => {
          if (!res.success) return;
          const companyData = Object.assign({}, res.body.company, res.body.webShopResource);
          this.$storage.company = companyData;
          if (companyData.htmlHints) {
            this.htmlHints = companyData.htmlHints;
            this.formatHtmlHints();
          }
          const setOrderType = companyData.orderTypes.includes('delivery') ? 'delivery' : companyData.orderTypes[0];
          this.$store.dispatch('setType', setOrderType);
          this.$store.dispatch('setCompany', companyData);
          this.$store.dispatch('setTimeZone', companyData.address.country === 'UK' ? 'Europe/London' : 'Europe/Vienna');
          this.$store.dispatch('setWorkingHours', companyData.openingDaysAndHours);
          document.title = `${companyData.name} Webshop`;
          if (this.$route.params.resource !== oldResourceId) {
            window.location.reload(true);
          }
        });
    } else if (this.$storage.company) {
      const companyData = this.$storage.company;
      if (companyData.htmlHints) {
        this.htmlHints = companyData.htmlHints;
        this.formatHtmlHints();
      }
      const setOrderType = companyData.orderTypes.includes('delivery') ? 'delivery' : companyData.orderTypes[0];
      this.$store.dispatch('setType', setOrderType);
      document.title = `${companyData.name} Webshop`;
    }
    if (this.$route.query.registered) {
      this.success = this.$lang.success.registrationSuccessfully;
    } else if (this.$route.query.passwordSet) {
      this.success = this.$lang.success.passSuccess;
    } else if (this.$route.query.orderSuccessful) {
      let fullLink = '';
      const ordercompletedlink = localStorage.ordercompletedlink ?
        JSON.parse(localStorage.ordercompletedlink) : false;
      if (ordercompletedlink) {
        fullLink = ordercompletedlink.backlink.replace('#orderId#', ordercompletedlink.orderId);
        fullLink = fullLink.replace('%23orderId%23', ordercompletedlink.orderId);
      }
      this.success = this.$lang.success.thankYou;
      this.orderBackLinkUrl = fullLink;
    } else if (this.$route.query.rateSuccessful) {
      this.success = this.$lang.success.rateOk;
    }
    if (this.success) {
      setTimeout(() => {
        this.success = '';
        this.orderBackLinkUrl = '';
      }, 180000);
    }
    const catalog = this.$storage.catalog;
    if (catalog) {
      this.$store.dispatch('setCatalog', catalog);
      this.loaded = true;
      // George asked to turn it off
      // this.initIntercom();
      return;
    }
    this.$webHelper.post('catalog/getcatalog', null, this.$router)
      .then((res) => {
        this.loaded = true;
        if (!res.success) {
          this.err = this.$lang.errors.failedCastalog;
          return;
        }
        this.$storage.catalog = res.body.catalog;
        this.$store.dispatch('setCatalog', res.body.catalog);
        // George asked to turn it off
        // this.initIntercom();
      });
  },
  mounted() {
    if (Object.keys(this.$route.query).length > 0) {
      this.setupQuery();
    }
  },
};
</script>

<style lang="scss">
.v-alert {
  border: unset !important;
}

h2 {
  font-size: 18px;
  font-weight: 500;
}

.section {
  height: auto;
  position: relative;
}

.categories {
  padding: 24px;
  margin-bottom: 16px;
}

.shopping-basket {

}

.my-btn {
  width: 24px !important;
  height: 24px !important;
  min-width: 10px !important;
}

@media only screen and (max-width: 992px) {
  .categories,
  .shopping-basket {
    width: 100%;
    max-width: 100%;
  }
}

@media only screen and (max-width: 600px) {
  .categories {
    padding: 0;
  }
}

#vCardId {
  overflow: unset !important;
}

.v-alert .v-alert__icon.v-icon, .v-alert__dismissible .v-icon {
  align-self: start !important;
  padding-top: 2px;
}

.notifications {
  font-size: 26px;
  a {
    display: inline-block;
    float: left;
    line-height: 30px;
    position: relative;
    top: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue